import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { removeActivePin } from '../../actions/map';
import { MapOfferCard } from '../../components/MapOfferCard';
import {
  selectActivePin,
  selectOfferByRealtyOfferIdForMap,
  selectOffersByRealtyOfferIdStatus,
  selectIsSearcherOrSub,
} from '../../selectors';
import { EDeviceType } from '../../types/device';

export const MapOfferCardContainer = () => {
  const dispatch = useDispatch();
  const [isCardOpen, setIsCardOpen] = React.useState(false);

  const selectedOffer = useSelector(selectOfferByRealtyOfferIdForMap);
  const offersByRealtyOfferIdStatus = useSelector(selectOffersByRealtyOfferIdStatus);
  const activePin = useSelector(selectActivePin);

  const isSearcherOrSub = useSelector(selectIsSearcherOrSub);

  React.useEffect(() => {
    setIsCardOpen(Boolean(activePin));
  }, [activePin]);

  const device = useDeviceType();

  const handleCloseOfferCard = () => {
    dispatch(removeActivePin());
  };

  if (device === EDeviceType.Phone) {
    return null;
  }

  return (
    <MapOfferCard
      isCardOpen={isCardOpen}
      handleCloseOfferCard={handleCloseOfferCard}
      offersByRealtyOfferIdStatus={offersByRealtyOfferIdStatus}
      selectedOffer={selectedOffer}
      isSearcherOrSub={isSearcherOrSub}
    />
  );
};
